import React, {
  useRef,
  useEffect,
} from 'react';
import {
  Form,
  Field,
  Formik,
} from 'formik';
import {
  CreateButton,
  DownloadPdfButton,
  DownloadExcelButton,
} from '../Controls';
import {
  Loader,
  TextBase,
  SelectBase,
  SwitchBase,
  DatePickerBase,
  GeneralPopover,
} from 'components';
import {
  Grid,
  Button,
  Toolbar,
  Tooltip,
  Popover,
  Typography,
  IconButton,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Search } from '@material-ui/icons';

function ToolBar({
  dates,
  columns,
  filters,
  onCreate,
  setFilter,
  ExtraToolBar,
  filtersTable,
  onDownloadPdf,
  maxWidthFilter,
  onDownloadExcel,
  createPermissions,
  updatePermissions,
}) {
  const formik = useRef();

  const [loading, setLoading] = React.useState(true);
  const [search, setSearch] = React.useState(filters);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [initialValues, setInitialValues] = React.useState({});

  const show = Boolean(anchorEl);

  const onClick = (event) => setAnchorEl(event.currentTarget);

  const onClose = () => setAnchorEl(null);

  const getInitialValues = (cols) => {
    const initValues = {};

    cols.forEach((item) => {
      if (item.type === 'date-time' || item.type === 'date' || item.type === 'time') {
        initValues[item.name] = null;
      } else {
        initValues[item.name] = '';
      }
    });

    setInitialValues(initValues);
    setLoading(false);
  };

  useEffect(() => {
    getInitialValues(columns);
    // eslint-disable-next-line
  }, []);

  const getType = (
    name,
    type,
    label,
  ) => {
    switch (type) {
      case 'status':
        return (
          <Field
            name={name}
            label={label}
            component={SelectBase}
            items={[
              { value: 'PENDIENTE', label: 'PENDIENTE' },
              { value: 'APROBADO', label: 'APROBADO' },
              { value: 'NO_APROBADO', label: 'NO_APROBADO' },
            ]}
          />
        );
      case 'date':
        return (
          <Field
            label={label}
            name={name}
            component={DatePickerBase}
            disablePast={false}
          />
        );
      case 'check':
        return (
          <Field
            name={name}
            label={label}
            component={SwitchBase}
            numberBoolean
          />
        );
      default:
        return (
          <Field
            label={label}
            name={name}
            component={TextBase}
          />
        );
    }
  };

  const handleSubmitFilter = (values) => {
    console.log(values);
    const noEmpty = {};
    // eslint-disable-next-line
    for (const prop in values) {
      const value = values[prop];
      if (value !== '' && value !== 0 && value !== null) {
        noEmpty[prop] = value;
      }
    }
    setFilter(noEmpty);
  };

  return (
    <>
      <Toolbar>
        <Grid
          container
          direction="row"
          style={{ paddingBottom: 20 }}
          justify={'flex-end'}
        >
          <Grid item style={{ display: 'flex', alignItems: 'center' }}>
            {ExtraToolBar}
            {filtersTable && (
              <Tooltip title="Buscar registros">
                <IconButton onClick={onClick}>
                  <Search fontSize="large" />
                </IconButton>
              </Tooltip>
            )}
            {onCreate && (
              <CreateButton
                onClick={onCreate}
                requiredPermissions={createPermissions}
              />
            )}
            {onDownloadExcel
              && (
                <DownloadExcelButton
                  onClick={() => onDownloadExcel(search)}
                  requiredPermissions={updatePermissions}
                />
              )}
            {onDownloadPdf
              && (
                <DownloadPdfButton
                  onClick={onDownloadPdf}
                  requiredPermissions={updatePermissions}
                />
              )}
          </Grid>
        </Grid>
      </Toolbar>
      {show && (
        <Popover
          open
          anchorEl={anchorEl}
          onClose={onClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Grid
            container
            spacing={2}
            direction="row"
            style={{ padding: 20, minWidth: 500 }}
          >
            <Typography variant="h6">
              Buscar registros
            </Typography>
          </Grid>
          <Grid
            container
            spacing={2}
            direction="row"
            style={{ padding: 10, maxWidth: maxWidthFilter }}
          >
            <>
              {loading ? <Loader /> : (
                <Formik
                  innerRef={formik}
                  initialValues={initialValues}
                  enableReinitialize
                  onSubmit={(values) => {
                    handleSubmitFilter(values);
                    onClose();
                  }}
                >
                  {subProps => (
                    <Form>
                      {dates && (
                        <Grid
                          container
                          spacing={2}
                          direction="row"
                          justify="center"
                        >
                          <Grid item xs={4} md={4} xl={4}>
                            <Field
                              name="dateInit"
                              label="Fecha inicio"
                              component={DatePickerBase}
                              disablePast={false}
                            />
                          </Grid>
                          <Grid item xs={4} md={4} xl={4}>
                            <Field
                              name="dateEnd"
                              label="Fecha fin"
                              disablePast={false}
                              component={DatePickerBase}
                              minDate={subProps.values.dateInit}
                              disabled={!subProps.values.dateInit}
                            />
                          </Grid>
                        </Grid>
                      )}
                      <Grid
                        container
                        spacing={2}
                        direction="row"
                        style={{ padding: 10, maxWidth: maxWidthFilter }}
                      >
                        {columns.map(({
                          name,
                          label,
                          type = '',
                          filter = true,
                          titleHelpMessage = '',
                        }, i) => (
                            <>
                              {filter ? (
                                <Grid
                                  item
                                  xs={4}
                                  md={4}
                                  lg={4}
                                  xl={4}
                                  key={`${String(i)}`}
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    gap: 5,
                                  }}
                                >
                                  {getType(name, type, label)}
                                  {Boolean(titleHelpMessage) && (<GeneralPopover message={titleHelpMessage} />)}
                                </Grid>
                              ) : []}
                            </>
                          ))}
                      </Grid>
                      <Grid container direction="row" spacing={2} style={{ padding: 10 }}>
                        <Grid item xs={6}>
                          <Button
                            color="primary"
                            variant="contained"
                            type="submit"
                          >
                            Filtrar
                          </Button>
                        </Grid>
                        <Grid item xs={6}>
                          <Button
                            color="primary"
                            variant="contained"
                            onClick={() => {
                              setFilter({});
                              setSearch({});
                            }}
                          >
                            Reiniciar
                          </Button>
                        </Grid>
                      </Grid>
                    </Form>
                  )}
                </Formik>
              )}
            </>
          </Grid>
        </Popover>
      )}
    </>
  );
}

ToolBar.defaultProps = {
  maxWidthFilter: 1200,
};

ToolBar.propTypes = {
  dates: PropTypes.bool,
  title: PropTypes.string,
  onCreate: PropTypes.func,
  setFilter: PropTypes.func,
  filtersTable: PropTypes.bool,
  ExtraToolBar: PropTypes.node,
  onDownloadPdf: PropTypes.func,
  onDownloadExcel: PropTypes.func,
  titleHelpMessage: PropTypes.string,
  maxWidthFilter: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  columns: PropTypes.oneOfType([PropTypes.array]),
  filters: PropTypes.oneOfType([PropTypes.object]),
  createPermissions: PropTypes.oneOfType([PropTypes.array]),
  updatePermissions: PropTypes.oneOfType([PropTypes.array]),
};

export default ToolBar;

